const FILTER = {
    /*********************
    * Refresh with Filter
    *********************/
    load(event) {
        event.preventDefault();
        XHR.load({
            nodeIds:      [event.target.dataset.xhr],
            url:          event.target.href,
            functionCall: [NICESELECT.onReady, FILEPOND.onReady]
        });
        window.history.replaceState(null, '', event.target.href);
        return;
    },
    /*********************
    * Refresh with Search
    *********************/
    search(event) {
        event.preventDefault();
        let form     = event.target.closest('form');
        let searchBy = form.querySelector('#search_by').value;
        let search   = form.querySelector('#search').value;
        let url      = location.protocol + '//' + location.host + location.pathname + '?searchBy=' + searchBy + '&search=' + search;
        XHR.load({
            nodeIds:      [form.dataset.xhr],
            url:          url,
            functionCall: [NICESELECT.onReady, FILEPOND.onReady]
        });
        window.history.replaceState(null, '', url);
        return;
    },
    /*********************
    * Refresh with Status
    *********************/
    status(that) {
        let url         = location.protocol + '//' + location.host + location.pathname;
        let queryString = window.location.search;
        let urlParams   = new URLSearchParams(queryString);
        let entries     = urlParams.entries();
        // Build new Query
        var newQuery = urlParams.has('status') ? '?' : `?status=${encodeURIComponent(that.value)}&`;
        for (let entry of entries) {
            if (entry[0] === 'status') {
                newQuery += `status=${encodeURIComponent(that.value)}&`;
            } else {
                newQuery += `${encodeURIComponent(entry[0])}=${encodeURIComponent(entry[1])}&`;
            }
        }
        newQuery = newQuery.slice(0, -1); // remove last "&"
        // Load
        XHR.load({
            nodeIds:      [that.dataset.xhr],
            url:          url + newQuery,
            functionCall: [NICESELECT.onReady, FILEPOND.onReady]
        });
        window.history.replaceState(null, '', url + newQuery);
        return;
    },
    /*********************
    * Refresh with Kind
    *********************/
    kind(that) {
        let url         = location.protocol + '//' + location.host + location.pathname;
        let queryString = window.location.search;
        let urlParams   = new URLSearchParams(queryString);
        let entries     = urlParams.entries();
        // Build new Query
        var newQuery = urlParams.has('kind') ? '?' : `?kind=${encodeURIComponent(that.value)}&`;
        for (let entry of entries) {
            if (entry[0] === 'kind') {
                newQuery += `kind=${encodeURIComponent(that.value)}&`;
            } else {
                newQuery += `${encodeURIComponent(entry[0])}=${encodeURIComponent(entry[1])}&`;
            }
        }
        newQuery = newQuery.slice(0, -1); // remove last "&"
        // Load
        XHR.load({
            nodeIds:      [that.dataset.xhr],
            url:          url + newQuery,
            functionCall: [NICESELECT.onReady, FILEPOND.onReady]
        });
        window.history.replaceState(null, '', url + newQuery);
        return;
    },
    /*********************
    * Refresh with Scorer
    *********************/
    scorer(that) {
        let url         = location.protocol + '//' + location.host + location.pathname;
        let filters     = document.querySelectorAll('[name="'+ that.name +'"]');
        let queryString = window.location.search;
        let urlParams   = new URLSearchParams(queryString);
        let entries     = urlParams.entries();
        //  Build Status Query
        var scorerQuery = '';
        filters.forEach(filter => {
            if (filter.checked) {
                scorerQuery += filter.value + ',';
            }
        });
        scorerQuery = scorerQuery.slice(0, -1); // remove last ","
        // Build new Query
        var newQuery = urlParams.has('scorer') ? '?' : `?scorer=${encodeURIComponent(scorerQuery)}&`;
        for (let entry of entries) {
            if (entry[0] === 'scorer') {
                newQuery += `scorer=${encodeURIComponent(scorerQuery)}&`;
            } else {
                newQuery += `${encodeURIComponent(entry[0])}=${encodeURIComponent(entry[1])}&`;
            }
        }
        newQuery = newQuery.slice(0, -1); // remove last "&"
        // Load
        XHR.load({
            nodeIds:      [that.dataset.xhr],
            url:          url + newQuery,
            functionCall: [NICESELECT.onReady, FILEPOND.onReady]
        });
        window.history.replaceState(null, '', url + newQuery);
        return;
    }
}